/**
 * Contador del carrito del header.
 *
 * El carrito vive en el `localStorage`, así que el contador se calcula en el
 * cliente. Escucha el CustomEvent `joyeria:carrito` que dispara el botón
 * "Agregar al carrito" y el propio carrito, para que el número se actualice
 * sin recargar.
 */
'use client';

import { useEffect, useState } from 'react';

const CLAVE_CARRITO = 'joyeria.carrito';

/** La cantidad total de unidades del carrito. */
function totalCarrito(): number {
  if (typeof window === 'undefined') return 0;
  try {
    const crudo = window.localStorage.getItem(CLAVE_CARRITO);
    if (!crudo) return 0;
    const datos = JSON.parse(crudo) as Record<string, number>;
    return Object.values(datos).reduce((acc, n) => acc + (Number(n) || 0), 0);
  } catch {
    return 0;
  }
}

export function CartCount() {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const actualizar = () => setTotal(totalCarrito());
    actualizar();

    // El evento lo dispara el agregar al carrito y el carrito.
    window.addEventListener('joyeria:carrito', actualizar);
    // Y el evento `storage` cubre otra pestaña.
    window.addEventListener('storage', actualizar);

    return () => {
      window.removeEventListener('joyeria:carrito', actualizar);
      window.removeEventListener('storage', actualizar);
    };
  }, []);

  return (
    <span className="cart-count" data-cart-count hidden={total === 0}>
      {total}
    </span>
  );
}
